import { useEffect } from 'react';
import { useSiteConfig } from '../contexts/SiteConfigContext';

function Analytics() {
  const { config } = useSiteConfig();
  const gaId = config?.ga4_measurement_id;
  const plausibleDomain = config?.plausible_domain;

  useEffect(() => {
    // Plausible - no cookie, no consent required
    if (plausibleDomain && !document.getElementById('plausible-script')) {
      const s = document.createElement('script');
      s.id = 'plausible-script';
      s.defer = true;
      s.src = 'https://plausible.io/js/script.js';
      s.setAttribute('data-domain', plausibleDomain);
      document.head.appendChild(s);
    }
  }, [plausibleDomain]);

  useEffect(() => {
    // GA4 - requires user consent (stored in localStorage)
    if (!gaId) return;
    const consent = localStorage.getItem('cookie_consent');
    if (consent !== 'accepted') return;
    if (document.getElementById('ga4-script')) return;

    const s = document.createElement('script');
    s.id = 'ga4-script';
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
    document.head.appendChild(s);

    window.dataLayer = window.dataLayer || [];
    function gtag() { window.dataLayer.push(arguments); }
    window.gtag = gtag;
    gtag('js', new Date());
    gtag('config', gaId, { anonymize_ip: true });
  }, [gaId]);

  return null;
}

export default Analytics;
